import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const CgbImageGalleryGridBlock = (props) => {
    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`iamge-gallery-grid ${props.attributes.className ? props.attributes.className : ''} ${classes.imageGalleryGrid} ${classes.imageGalleryGridTheme}`}>
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const CgbImageGalleryGridBlockFragment = graphql`
  fragment CgbImageGalleryGridBlock on WpBlock {
    ... on WpCgbImageGalleryGridBlock {
        name
        attributes {
            className
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbImageGalleryGridBlockPreview = `
    ... on CgbImageGalleryGridBlock {
        name
        attributes {
            className
        }
    }
`;